import type { NodeV2 } from '@vedalib/editor'
import React, { useMemo } from 'react'

import { applyArea } from 'components/Editor/NodeV2/formControls/Area/utils'
import { useProjectContext } from 'services/Store/Project/hooks'
import { getNodeStyle, getPlaceholders } from 'services/Store/Project/selectors'
import type { Block, IBlockMode } from 'services/Store/Project/types'

import * as s from './DragPlaceholderGrid.module.scss'

interface IPlaceholderProps {
  block: Block
  node: NodeV2
  mode: IBlockMode
  nodeRef: React.RefObject<HTMLDivElement>
}

const DragPlaceholderGrid: React.FC<IPlaceholderProps> = ({ block, node }) => {
  const dnd = useProjectContext(getPlaceholders, node.id)
  const cells = useMemo(() => Object.values(dnd?.areas || {}), [dnd?.areas])

  const styles = useProjectContext(getNodeStyle, block.uuid, node.id)

  const groupArea = useMemo(
    () =>
      cells?.reduce(
        (acc, cur) => ({
          rowStart: Math.min(acc.rowStart, cur.rowStart),
          colStart: Math.min(acc.colStart, cur.colStart),
          rowEnd: Math.max(acc.rowEnd, cur.rowEnd),
          colEnd: Math.max(acc.colEnd, cur.colEnd),
        }),
        { rowStart: Infinity, colStart: Infinity, rowEnd: -Infinity, colEnd: -Infinity },
      ),
    [cells],
  )

  return (
    <>
      {(dnd?.targetIds?.length || 0) > 1 && (
        <div className={s.group} style={{ gridArea: applyArea(styles, groupArea) }} />
      )}
      {cells?.map((gridArea, idx) => (
        <div
          className={s.element}
          key={dnd?.targetIds?.[idx]}
          style={{ gridArea: applyArea(styles, gridArea) }}
        />
      ))}
    </>
  )
}

export default DragPlaceholderGrid
